import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const sections = [
  { id: 'hero', icon: '🏠', label: 'header.home' },
  { id: 'features', icon: '⚡', label: 'features.title' },
  { id: 'stats', icon: '📊', label: 'stats.title' },
  { id: 'testimonials', icon: '💬', label: 'testimonials.title' },
  { id: 'blog', icon: '📝', label: 'blog.title' },
  { id: 'contact', icon: '📞', label: 'contact.title' }
];

const FloatingNav = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      // Afficher la navigation après 100px de défilement
      setIsVisible(window.scrollY > 100);

      // Détecter la section active
      const sectionElements = sections.map(section => ({
        id: section.id,
        element: document.getElementById(section.id)
      }));

      const currentSection = sectionElements.find(section => {
        if (!section.element) return false;
        const rect = section.element.getBoundingClientRect();
        return rect.top <= 150 && rect.bottom >= 150;
      });

      if (currentSection) {
        setActiveSection(currentSection.id);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Tenir compte de la hauteur du header
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -100 }}
          className="fixed left-4 top-1/2 transform -translate-y-1/2 z-50"
        >
          <nav className="bg-white rounded-lg shadow-lg p-2">
            <ul className="space-y-2">
              {sections.map((section) => (
                <li key={section.id}>
                  <button
                    onClick={() => scrollToSection(section.id)}
                    className={`w-full flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                      activeSection === section.id
                        ? 'bg-indigo-600 text-white'
                        : 'hover:bg-gray-100 text-gray-700'
                    }`}
                    title={t(section.label)}
                  >
                    <span className="text-xl">{section.icon}</span>
                    <motion.span
                      initial={{ opacity: 0, width: 0 }}
                      whileHover={{ opacity: 1, width: 'auto' }}
                      className="whitespace-nowrap overflow-hidden"
                    >
                      {t(section.label)}
                    </motion.span>
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingNav;
